function getVariantIdFromUrl() {
  // Get the complete current URL
  const currentUrl = window.location.href

  // Use the URL constructor to parse the URL
  const url = new URL(currentUrl)

  // Use URLSearchParams to access query parameters
  const params = new URLSearchParams(url.search)

  // Get the value associated with the 'variant' key
  return params.get('variant')
}

function GdcAddBundleToCart(items) {
  fetch('/cart/add.js', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify({ items: items }),
  })
    .then((response) => response.json())
    .then((data) => {
      const miniCart = document.querySelector('[data-minicart-input]')

      miniCart.click()

    })
    .catch((error) => {
      console.error('Error adding to cart:', error)
    })
}
